<script setup lang="ts">
import { getLangText } from '@/ts/utils/model-utils';
import { navigateTo } from '@/ts/management/view-navigation-management';
import casinoIcon from './assets/casino.svg?raw';
import model from '@/ts/model';
import { isNavViewItemActive } from './mobile-nav-bottom';
</script>

<template>
    <div class="nav-item" @click.prevent.stop="navigateTo('casino')" :class="{active: isNavViewItemActive('casino')}">
        <div class="icon" v-html="casinoIcon"></div>
        <div class="name">{{ getLangText('Casino', undefined, 'mobile-nav-bottom') }}</div>
    </div>
</template>

<style lang="scss" scoped>
@use './nav-item.scss';
</style>